import type { time } from '@amcharts/amcharts5';

export interface DateAxisBaseInterval {
  timeUnit: time.TimeUnit;
  count: number;
}

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export function msToBaseInterval(ms: number, fallback: DateAxisBaseInterval): DateAxisBaseInterval {
  if (!Number.isFinite(ms) || ms <= 0) {
    return fallback;
  }
  if (ms < MINUTE_MS) {
    return { timeUnit: 'second', count: Math.max(1, Math.round(ms / SECOND_MS)) };
  }
  if (ms < HOUR_MS) {
    return { timeUnit: 'minute', count: Math.max(1, Math.round(ms / MINUTE_MS)) };
  }
  if (ms < DAY_MS) {
    return { timeUnit: 'hour', count: Math.max(1, Math.round(ms / HOUR_MS)) };
  }
  return { timeUnit: 'day', count: Math.max(1, Math.round(ms / DAY_MS)) };
}

export function positiveDeltas(sortedTimestamps: number[]): number[] {
  const deltas: number[] = [];
  for (let i = 1; i < sortedTimestamps.length; i++) {
    const delta = sortedTimestamps[i] - sortedTimestamps[i - 1];
    if (delta > 0) {
      deltas.push(delta);
    }
  }
  return deltas;
}

export function upperMedian(values: number[]): number | null {
  if (values.length === 0) {
    return null;
  }
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.floor(sorted.length / 2)];
}
